import { createContext, useContext } from 'react';

import { Toast } from './types';

type ToastContextType = {
  toasts: Toast[];
  addToast: (toast: Toast) => void;
  clearToasts: () => void;
  clearToast: (key: Toast['key']) => void;
};

export const ToastContext = createContext<ToastContextType | null>(null);

export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToastContext must be used within a ToastProvider');
  }
  return context;
};
